module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-regular.176f8f5.woff2";